import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { GenericCarrierAccountValue } from '@/api/Carrier/getGenericCarrierAccountsQuery';

const CARRIER_UNIQUE_NAME = ':carrierUniqueName';

// eslint-disable-next-line max-len
const ENDPOINT = `${APIConfiguration.carrier}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/carriers/genericAccount/${CARRIER_UNIQUE_NAME}`;

export interface UpsertGenericCarrierAccountCommandArgs {
  sellerId: string;
  carrierUniqueName: string;
  account: Record<string, GenericCarrierAccountValue>;
}

export interface UpsertedGenericCarrierAccountSummary {
  id: string;
  carrier: string;
  name: string;
}

export const upsertGenericCarrierAccountRequest = ({
  sellerId,
  carrierUniqueName,
  account,
}: UpsertGenericCarrierAccountCommandArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId).replace(
    CARRIER_UNIQUE_NAME,
    carrierUniqueName.toLowerCase(),
  ),
  config: {
    method: SUPPORTED_METHODS.POST,
    json: { ...account, sellerId, skipRulesIntegrityCheck: true },
  },
});

export async function upsertGenericCarrierAccountCommand(
  payload: UpsertGenericCarrierAccountCommandArgs,
): Promise<
  BackResponse<UpsertedGenericCarrierAccountSummary> | BackResponseFailure
> {
  try {
    return await executeQuery<
      BackResponse<UpsertedGenericCarrierAccountSummary>
    >(upsertGenericCarrierAccountRequest(payload));
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
